var Modal = {
    init: function() {
        this.buildHandlers();
    },
    buildHandlers: function() {
        $('.x').on('click', function() {
            $('.modal .video-wrapper iframe').remove();
            $('.modal').removeClass('show').addClass('hide');
        });
        $('.banner').find('img').on('click', function(e) {
            if ($(this).data('modal-link') !== undefined) {
                var html = '<iframe title="youtube-video" src="'+$(this).data('modal-link')+'" frameborder="0" allowfullscreen=""></iframe>';
                $('.modal .video-wrapper').html(html);
                $('.modal').addClass('hide').removeClass('show');
            }
        });
    }
}
